import { SearchProducts } from "@nosto/nosto-js/client"
import Button from "@/elements/Button/Button"
import Heading from "@/elements/Heading/Heading"
import DynamicCardProduct from "@/components/Autocomplete/DynamicCardProduct/DynamicCardProduct"
import { dedupeByStyleFamily } from "@/utils/dedupeByStyleFamily"
import type { Product } from "@/types"
import style from "./Results.module.css"

export type ProductsProps = {
  products: SearchProducts
}

export default function Products({ products }: ProductsProps) {
  if (!products?.hits?.length) {
    return null
  }

  // Collapse sibling color products in the autocomplete drawer to one
  // suggestion per style family (Agent F). Keeps autocomplete consistent with
  // the PLP/search grid, which also dedupes by `styleFamilyKey`. Hits without
  // an indexed style family are preserved as-is by `dedupeByStyleFamily`.
  const visibleHits = dedupeByStyleFamily(products.hits as Product[])

  return (
    <div className={style.productsColumn}>
      <Heading>Products</Heading>
      <div className={style.products}>
        {visibleHits.map(hit => (
          <DynamicCardProduct key={hit.productId} hit={hit} />
        ))}
      </div>
      <div className={style.button}>
        <Button type="submit" className={style.submit}>
          See all search results
        </Button>
      </div>
    </div>
  )
}
